/**
 * Badge — 인라인 상태/카테고리 뱃지
 *
 * 작은 pill 형태로 상태를 표시한다. 색상은 tokens.css 변수를 사용한다.
 */

import { ReactNode } from 'react'
import { cn } from '../../lib/cn.js'
import styles from './Badge.module.css'

interface BadgeProps {
  /** 뱃지 색상 변형. 기본값 gray */
  color?: 'gray' | 'blue' | 'green' | 'red' | 'yellow'
  className?: string
  children: ReactNode
}

export function Badge({ color = 'gray', className, children }: BadgeProps) {
  return <span className={cn(styles.root, styles[color], className)}>{children}</span>
}
